import * as aor from "react-admin";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MyBooleanInput from "./MyBooleanInput";

const styles = {
    inlineBlock: { display: "inline-flex", marginRight: "1rem" }
};

const MyToolbar = props => (
    <aor.Toolbar {...props}>
        <aor.SaveButton submitOnEnter={true} />
    </aor.Toolbar>
);

const LockOption = ({ record }) => {
    if (record && record.installations_lock) {
        return record.installations_lock.map(i => {
            return <MyBooleanInput id={i.id} label={i.name} lock={i.lock} />;
        });
    } else {
        return null;
    }
};

export default withStyles(styles)(({ permissions, classes, ...props }) => (
    <aor.Edit
        {...props}
        basePath="/configs"
        resource="configs"
        undoable={false}
        title={"resources.configs.nameSingular"}
        id={1}
    >
        <aor.SimpleForm toolbar={<MyToolbar />}>
            <br />
            <div style={{ whiteSpace: "nowrap" }}>
                <aor.Labeled label="resources.configs.labels.maintenanceLock"></aor.Labeled>
            </div>
            <aor.BooleanInput source="portal_lock" />
            <LockOption />
        </aor.SimpleForm>
    </aor.Edit>
));



// WEBPACK FOOTER //
// ./src/components/ConfigEdit.js